import React from 'react';
import HrnbCard from '../controls/HrnbCard';
import './AnnualWinnersList.css';

/**
 * Список победителей ежегодных турниров
 * @param {Object} props
 * @param {Array} props.winners - Победители по годам
 */
function AnnualWinnersList({ winners }) {
    if (!winners || winners.length === 0) {
        return null;
    }

    return (
        <div className="annual-winners-list">
            {winners.map((winner, index) => (
                <HrnbCard 
                    key={winner.year || winner.tournamentId} 
                    className={`annual-winners-list__item annual-winners-list__item--rank-${index + 1}`}
                >
                    <div className="annual-winners-list__year">
                        {winner.year}
                    </div>
                    
                    <div className="annual-winners-list__content">
                        {/* Победитель */}
                        <div className="annual-winners-list__winner">
                            <div className="annual-winners-list__medal annual-winners-list__medal--gold">
                                🥇
                            </div>
                            <div className="annual-winners-list__participant">
                                {winner.winnerAvatar && (
                                    <img 
                                        src={winner.winnerAvatar} 
                                        alt={winner.winnerName}
                                        className="annual-winners-list__avatar"
                                    />
                                )}
                                <div className="annual-winners-list__name">
                                    <div className="annual-winners-list__title">Чемпион</div>
                                    <strong>{winner.winnerName}</strong>
                                </div>
                            </div>
                            {winner.prizeAmount && (
                                <div className="annual-winners-list__prize">
                                    {winner.prizeAmount.toLocaleString('ru-RU')} {winner.currency}
                                </div>
                            )}
                        </div>

                        {/* Финалист */}
                        {winner.runnerUpName && (
                            <div className="annual-winners-list__runner-up">
                                <div className="annual-winners-list__medal annual-winners-list__medal--silver">
                                    🥈
                                </div>
                                <div className="annual-winners-list__participant">
                                    {winner.runnerUpAvatar && (
                                        <img 
                                            src={winner.runnerUpAvatar} 
                                            alt={winner.runnerUpName}
                                            className="annual-winners-list__avatar"
                                        />
                                    )}
                                    <div className="annual-winners-list__name">
                                        <div className="annual-winners-list__title">Финалист</div>
                                        {winner.runnerUpName}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Счёт финала */}
                        {winner.finalScore && (
                            <div className="annual-winners-list__score">
                                Счёт в финале: <strong>{winner.finalScore}</strong>
                            </div>
                        )}
                    </div>
                </HrnbCard>
            ))}
        </div>
    );
}

export default AnnualWinnersList;
